import { readJcampFromURL } from '../reader/readJcamp';
export async function getSourceCache(data, options = {}) {
    const { jcampParsingOptions } = options;
    const uniqueSourceURL = getUniqueSourceURL(data);
    const promises = uniqueSourceURL.map((sourceURL) => readJcampFromURL(sourceURL, jcampParsingOptions));
    const parsedSources = await Promise.all(promises);
    const sourceCache = {};
    for (let i = 0; i < uniqueSourceURL.length; i++) {
        sourceCache[uniqueSourceURL[i]] = parsedSources[i];
    }
    return sourceCache;
}
function getUniqueSourceURL(data) {
    const uniqueSourceURL = new Set();
    for (let datum of data.spectra) {
        if (datum.source.jcampURL != null) {
            uniqueSourceURL.add(datum.source.jcampURL);
        }
    }
    return Array.from(uniqueSourceURL);
}
//# sourceMappingURL=getSourceCache.js.map